import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import Constants from '../../../../definitions/constants';

import TextBox from '../inputs/textBox';
import Select from '../inputs/select';
import Label from '../inputs/label';

const EntityMetricsInputs = props => {
  const {
    metricsStatus,
    formData,
    metricsOptionsLists,
    handleOnChangeForm
  } = props;
  return (
    <div>
      {metricsStatus==200 && (
        <Label 
          label={<FormattedMessage id="metricAdmin.entityNamePluralFirstUpper"/>}
          className="entity_metrics_label"
        />
      )}
      {(metricsStatus==200 && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric_values")) &&
        Object.keys(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric_values")).map((key,i) => {
          let item = JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric_values")[key];
          let path = "metric_values." + key + ".metric_value";
          if(item.validation_dimension_id && metricsOptionsLists[item.validation_dimension_id]) {
            return  (
              <Select 
                key={i}
                id={"metric-"+key}
                data-path={path}
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,path)}
                onChange={handleOnChangeForm}
                labelLocale={item.metric_name}
                options={InterfaceTooling.getSelectArrayFromArrayOfObjects(
                  (metricsOptionsLists && metricsOptionsLists[item.validation_dimension_id]) ? 
                  metricsOptionsLists[item.validation_dimension_id] : [], "value", "value")}
              />
            );
          }
          else {
            var dataTypeAux = item.validation_dimension_type ? item.validation_dimension_type : item.metric_data_type;
            return (
              <TextBox 
                key={i}
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                type={Constants.interface.inputs.type.TEXT}
                id={"metric-"+key}
                data-path={path}
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,path)}
                onChange={handleOnChangeForm}
                labelLocale={item.metric_name + " (" + intl.formatMessage({ id: "metricAdmin.fields.selectValues.data_type.helpers." + dataTypeAux}) + ")"}
                dataType={dataTypeAux}
              />
            )
          }
        })
      }
    </div>
  );
};

export default EntityMetricsInputs;



// WEBPACK FOOTER //
// ./source/client/components/common/entity/entityMetricsInputs.jsx